export const setJwtTokenToIosStore = (token) => {
  if (
    window.webkit &&
    window.webkit.messageHandlers &&
    window.webkit.messageHandlers.print
  ) {
    console.info("Setting JWT token to iOS store");
    window.webkit.messageHandlers.jwtToken.postMessage({ token });
  } else {
    console.info("print handler not available");
  }
};

export const vibrateOnIos = () => {
  if (
    window.webkit &&
    window.webkit.messageHandlers &&
    window.webkit.messageHandlers.vibrate
  ) {
    console.info("Vibrating iOS device");
    window.webkit.messageHandlers.vibrate.postMessage("menu-item-clicked");
  } else {
    console.info("vibrate handler not available");
  }
};
